import { AckDocumentCriterion } from 'features/ack-documents/types';

/**
 * Подпись аудитории документа. Критерии объединяются по «И», пустой список — все участники.
 * Неизвестный бэку критерий приходит с title «Неизвестный критерий» — выводим его как есть.
 */
export const describeAudience = (
  criteria: AckDocumentCriterion[] | null | undefined,
  t: (code: string) => string,
): string => {
  if (!criteria?.length) {
    return t('hubstr.ack_documents.audience.all');
  }

  return criteria
    .map((criterion) => {
      if (criterion.type === 'position_tags') {
        const title = criterion.title || t('hubstr.ack_documents.audience.labels');
        const names = (criterion.tags ?? []).map((tag) => tag.name).join(', ');
        return names ? `${title}: ${names}` : title;
      }

      return criterion.title || criterion.type;
    })
    .join('; ');
};
